(function (global) {
  'use strict';

  // Current mission names compiled from the Church's official 2024-2026
  // mission leadership assignment tables. Customers may still type a
  // mission name that is not yet present in this convenience list.
  const missions = [
  "Adriatic North",
  "Alabama Birmingham",
  "Alaska Anchorage",
  "Albania Tirana",
  "Alpine German-Speaking",
  "Angola Luanda",
  "Angola Luanda North",
  "Argentina Bahía Blanca",
  "Argentina Buenos Aires East",
  "Argentina Buenos Aires North",
  "Argentina Buenos Aires South",
  "Argentina Buenos Aires West",
  "Argentina Comodoro Rivadavia",
  "Argentina Córdoba",
  "Argentina Mendoza",
  "Argentina Neuquén",
  "Argentina Resistencia",
  "Argentina Rosario",
  "Argentina Salta",
  "Argentina Santa Fe",
  "Argentina Tucumán",
  "Arizona Flagstaff",
  "Arizona Gilbert",
  "Arizona Mesa",
  "Arizona Phoenix East",
  "Arizona Phoenix West",
  "Arizona Tempe",
  "Arizona Tucson",
  "Arkansas Bentonville",
  "Arkansas Little Rock",
  "Armenia/Georgia",
  "Australia Adelaide",
  "Australia Brisbane",
  "Australia Brisbane South",
  "Australia Melbourne",
  "Australia Perth",
  "Australia Sydney",
  "Baltic",
  "Barbados Bridgetown",
  "Belgium/Netherlands",
  "Benin Cotonou",
  "Bolivia Cochabamba North",
  "Bolivia Cochabamba South",
  "Bolivia La Paz",
  "Bolivia Santa Cruz",
  "Bolivia Santa Cruz North",
  "Botswana/Namibia",
  "Brazil Belém",
  "Brazil Belo Horizonte",
  "Brazil Brasília",
  "Brazil Campinas",
  "Brazil Cuiabá",
  "Brazil Curitiba",
  "Brazil Curitiba South",
  "Brazil Feira de Santana",
  "Brazil Florianopolis",
  "Brazil Fortaleza",
  "Brazil Fortaleza East",
  "Brazil Goiânia",
  "Brazil Guarulhos",
  "Brazil João Pessoa",
  "Brazil Juiz de Fora",
  "Brazil Londrina",
  "Brazil Maceió",
  "Brazil Manaus North",
  "Brazil Manaus South",
  "Brazil Natal",
  "Brazil Piracicaba",
  "Brazil Porto Alegre North",
  "Brazil Porto Alegre South",
  "Brazil Recife North",
  "Brazil Recife South",
  "Brazil Ribeirão Preto",
  "Brazil Rio de Janeiro North",
  "Brazil Rio de Janeiro South",
  "Brazil Salvador",
  "Brazil Santa Maria",
  "Brazil Santos",
  "Brazil São Bernardo",
  "Brazil São Paulo East",
  "Brazil São Paulo Interlagos",
  "Brazil São Paulo North",
  "Brazil São Paulo South",
  "Brazil São Paulo West",
  "Brazil Sorocaba",
  "Brazil Teresina",
  "Brazil Vitoria",
  "Bulgaria Sofia",
  "California Anaheim",
  "California Arcadia",
  "California Bakersfield",
  "California Carlsbad",
  "California Fresno",
  "California Los Angeles",
  "California Modesto",
  "California Newport Beach",
  "California Oakland/San Francisco",
  "California Ontario",
  "California Riverside",
  "California Roseville",
  "California Sacramento",
  "California San Bernardino",
  "California San Diego",
  "California San Jose",
  "California Santa Rosa",
  "California Ventura",
  "California Victorville",
  "Cambodia Phnom Penh East",
  "Cambodia Phnom Penh West",
  "Cameroon Yaoundé",
  "Canada Calgary",
  "Canada Edmonton",
  "Canada Halifax",
  "Canada Montréal",
  "Canada Toronto",
  "Canada Toronto East",
  "Canada Vancouver",
  "Canada Winnipeg",
  "Cape Verde Mindelo",
  "Cape Verde Praia",
  "Chile Antofagasta",
  "Chile Concepción",
  "Chile Concepción South",
  "Chile La Serena",
  "Chile Puerto Montt",
  "Chile Rancagua",
  "Chile Santiago East",
  "Chile Santiago North",
  "Chile Santiago South",
  "Chile Santiago West",
  "Chile Viña del Mar",
  "China Hong Kong",
  "Colombia Barranquilla",
  "Colombia Bogotá North",
  "Colombia Bogotá South",
  "Colombia Cali",
  "Colombia Medellin",
  "Colorado Colorado Springs",
  "Colorado Denver East",
  "Colorado Denver South",
  "Colorado Fort Collins",
  "Costa Rica San José East",
  "Costa Rica San José West",
  "Cote d'Ivoire Abidjan East",
  "Cote d'Ivoire Abidjan North",
  "Cote d'Ivoire Abidjan South",
  "Cote d’Ivoire Abidjan West",
  "Cote d'Ivoire Daloa",
  "Cote d'Ivoire Yamoussoukro",
  "Czech/Slovak",
  "Democratic Republic of the Congo Kananga",
  "Democratic Republic of the Congo Kinshasa East",
  "Democratic Republic of the Congo Kinshasa North",
  "Democratic Republic of the Congo Kinshasa South",
  "Democratic Republic of the Congo Kinshasa West",
  "Democratic Republic of the Congo Kolwezi",
  "Democratic Republic of the Congo Lubumbashi",
  "Democratic Republic of the Congo Mbuji-Mayi",
  "Democratic Republic of the Congo Mwene-Ditu",
  "Denmark Copenhagen",
  "Dominican Republic Santiago",
  "Dominican Republic Santo Domingo East",
  "Dominican Republic Santo Domingo North",
  "Dominican Republic Santo Domingo West",
  "Ecuador Guayaquil East",
  "Ecuador Guayaquil North",
  "Ecuador Guayaquil South",
  "Ecuador Guayaquil West",
  "Ecuador Quito",
  "Ecuador Quito North",
  "Ecuador Quito West",
  "El Salvador San Salvador East",
  "El Salvador San Salvador West",
  "El Salvador Santa Ana",
  "England Birmingham",
  "England Bristol",
  "England Leeds",
  "England London",
  "England Manchester",
  "Ethiopia Addis Ababa",
  "Europe Central Turkic and Persian-Speaking",
  "Fiji Suva",
  "Finland Helsinki",
  "Florida Fort Lauderdale",
  "Florida Jacksonville",
  "Florida Orlando",
  "Florida Tallahassee",
  "Florida Tampa",
  "France Lyon",
  "France Paris North",
  "France Paris South",
  "Georgia Atlanta",
  "Georgia Atlanta North",
  "Germany Berlin",
  "Germany Frankfurt",
  "Germany Hamburg",
  "Ghana Accra East",
  "Ghana Accra North",
  "Ghana Accra South",
  "Ghana Accra West",
  "Ghana Cape Coast",
  "Ghana Kumasi",
  "Ghana Sunyani",
  "Ghana Takoradi",
  "Greece Athens",
  "Guatemala Antigua",
  "Guatemala Cobán/Belize",
  "Guatemala Guatemala City",
  "Guatemala Guatemala City Central",
  "Guatemala Guatemala City East",
  "Guatemala Quetzaltenango",
  "Guatemala Retalhuleu",
  "Guyana Georgetown",
  "Haiti Port-au-Prince",
  "Hawaii Honolulu Mission",
  "Hawaii Laie",
  "Honduras Comayagüela",
  "Honduras San Pedro Sula East",
  "Honduras San Pedro Sula West",
  "Honduras Tegucigalpa",
  "Hungary Budapest",
  "Idaho Boise",
  "Idaho Coeur d’Alene",
  "Idaho Idaho Falls",
  "Idaho Pocatello",
  "Illinois Chicago",
  "India Bengaluru",
  "India New Delhi",
  "Indiana Fort Wayne",
  "Indiana Indianapolis",
  "Indonesia Jakarta",
  "Iowa Iowa City",
  "Italy Milan",
  "Italy Rome",
  "Jamaica Kingston",
  "Japan Fukuoka",
  "Japan Kobe",
  "Japan Nagoya",
  "Japan Sapporo",
  "Japan Sendai",
  "Japan Tokyo North",
  "Japan Tokyo South",
  "Kansas Wichita",
  "Kentucky Louisville",
  "Kenya Kisumu",
  "Kenya Nairobi East",
  "Kenya Nairobi West",
  "Korea Busan",
  "Korea Seoul",
  "Korea Seoul South",
  "Liberia Monrovia",
  "Liberia Monrovia West",
  "Louisiana Baton Rouge",
  "Madagascar Antananarivo North",
  "Madagascar Antananarivo South",
  "Malawi Lilongwe",
  "Marshall Islands/Kiribati",
  "Maryland Baltimore",
  "Massachusetts Boston",
  "México Aguascalientes",
  "México Cancún",
  "México Chihuahua",
  "México Ciudad Juárez",
  "México Cuernavaca",
  "México Culiacán",
  "México Guadalajara",
  "México Guadalajara East",
  "México Hermosillo",
  "México Mérida",
  "México Mexicali",
  "México México City Chalco",
  "México México City East",
  "México México City North",
  "México México City Northwest",
  "México México City South",
  "México México City Southeast",
  "México México City West",
  "México Monterrey East",
  "México Monterrey West",
  "México Oaxaca",
  "México Pachuca",
  "México Puebla East",
  "México Puebla North",
  "México Puebla South",
  "México Querétaro",
  "México Saltillo",
  "México Tampico",
  "México Tijuana",
  "México Torreón",
  "México Tula",
  "México Tuxtla",
  "México Veracruz",
  "México Villahermosa",
  "México Xalapa",
  "Michigan Detroit",
  "Michigan Lansing",
  "Micronesia Guam",
  "Minnesota Minneapolis",
  "Mississippi Jackson",
  "Missouri Independence",
  "Missouri Kansas City",
  "Missouri St Louis",
  "Mongolia Ulaanbaatar",
  "Mongolia Ulaanbaatar West",
  "Montana Billings",
  "Montana Missoula",
  "Mozambique Beira",
  "Mozambique Maputo",
  "Mozambique Nampula",
  "Nebraska Omaha",
  "Nevada Henderson",
  "Nevada Las Vegas East",
  "Nevada Las Vegas West",
  "Nevada Reno",
  "New Hampshire Manchester",
  "New Jersey Morristown",
  "New Mexico Albuquerque",
  "New Mexico Farmington",
  "New York New York City",
  "New York Syracuse",
  "New Zealand Auckland",
  "New Zealand Hamilton",
  "New Zealand Wellington",
  "Nicaragua Managua North",
  "Nicaragua Managua South",
  "Nigeria Aba",
  "Nigeria Abuja",
  "Nigeria Benin City",
  "Nigeria Calabar",
  "Nigeria Enugu",
  "Nigeria Ibadan",
  "Nigeria Lagos",
  "Nigeria Owerri",
  "Nigeria Port Harcourt North",
  "Nigeria Port Harcourt South",
  "Nigeria Uyo",
  "North Carolina Charlotte",
  "North Carolina Raleigh",
  "North Dakota Bismarck",
  "Norway Oslo",
  "Ohio Cincinnati",
  "Ohio Columbus",
  "Oklahoma Oklahoma City",
  "Oklahoma Tulsa",
  "Oregon Eugene",
  "Oregon Portland",
  "Oregon Salem",
  "Panamá Panamá City",
  "Papua New Guinea Daru",
  "Papua New Guinea Lae",
  "Papua New Guinea Madang",
  "Papua New Guinea Port Moresby",
  "Paraguay Asunción",
  "Paraguay Asunción East",
  "Paraguay Asunción North",
  "Pennsylvania Philadelphia",
  "Pennsylvania Pittsburgh",
  "Perú Arequipa",
  "Perú Chiclayo",
  "Perú Cusco",
  "Perú Huancayo",
  "Perú Iquitos",
  "Perú Lima Central",
  "Perú Lima East",
  "Perú Lima Limatambo",
  "Perú Lima North",
  "Perú Lima Northeast",
  "Perú Lima Northwest",
  "Perú Lima South",
  "Perú Lima West",
  "Perú Piura",
  "Perú Tacna",
  "Perú Trujillo North",
  "Perú Trujillo South",
  "Philippines Angeles",
  "Philippines Antipolo",
  "Philippines Bacolod",
  "Philippines Baguio",
  "Philippines Butuan",
  "Philippines Cabanatuan",
  "Philippines Cagayan de Oro",
  "Philippines Cauayan",
  "Philippines Cavite",
  "Philippines Cebu",
  "Philippines Cebu East",
  "Philippines Davao",
  "Philippines Dumaguete",
  "Philippines General Santos",
  "Philippines Iloilo",
  "Philippines Laoag",
  "Philippines Legazpi",
  "Philippines Lingayen",
  "Philippines Lipa",
  "Philippines Manila",
  "Philippines Naga",
  "Philippines Olongapo",
  "Philippines Ormoc",
  "Philippines Ozamiz",
  "Philippines Puerto Princesa",
  "Philippines Quezon City",
  "Philippines Quezon City North",
  "Philippines San Pablo",
  "Philippines Tacloban",
  "Philippines Tuguegarao",
  "Philippines Urdaneta",
  "Poland Warsaw",
  "Portugal Lisbon",
  "Portugal Porto",
  "Puerto Rico San Juan",
  "Republic of Congo Brazzaville",
  "Romania Bucharest",
  "Russia Moscow",
  "Russia Yekaterinburg",
  "Rwanda Kigali",
  "Samoa Apia",
  "Samoa Apia West",
  "Scotland/Ireland",
  "Senegal Dakar",
  "Sierra Leone Bo",
  "Sierra Leone Freetown",
  "Singapore",
  "Solomon Islands Honiara",
  "South Africa Cape Town",
  "South Africa Durban",
  "South Africa East London",
  "South Africa Johannesburg",
  "South Africa Pretoria",
  "South Carolina Charleston",
  "South Carolina Columbia",
  "Spain Barcelona",
  "Spain Madrid East",
  "Spain Madrid North",
  "Spain Madrid South",
  "Sweden Stockholm",
  "Tahiti Papeete",
  "Taiwan Kaohsuing",
  "Taiwan Taipei",
  "Tanzania Dar es Salaam",
  "Tennessee Knoxville",
  "Tennessee Nashville",
  "Texas Austin",
  "Texas Dallas East",
  "Texas Dallas North",
  "Texas Dallas South",
  "Texas El Paso",
  "Texas Fort Worth",
  "Texas Houston East",
  "Texas Houston North",
  "Texas Houston South",
  "Texas Houston West",
  "Texas Lubbock",
  "Texas McAllen",
  "Texas San Antonio",
  "Texas San Antonio South",
  "Thailand Bangkok East",
  "Thailand Bangkok West",
  "Togo Lomé",
  "Tonga Nuku’alofa",
  "Uganda Kampala",
  "Uganda Kampala East",
  "Ukraine Kyiv/Moldova",
  "Uruguay Montevideo",
  "Uruguay Montevideo West",
  "Uruguay Salto",
  "Utah Layton",
  "Utah Ogden",
  "Utah Orem",
  "Utah Provo",
  "Utah Salt Lake City",
  "Utah Salt Lake City East",
  "Utah Salt Lake City Headquarters",
  "Utah Salt Lake City South",
  "Utah Salt Lake City West",
  "Utah Saratoga Springs",
  "Utah Spanish Fork",
  "Utah St. George",
  "Vanuatu Port Vila",
  "Venezuela Barcelona",
  "Venezuela Caracas",
  "Venezuela Maracaibo",
  "Venezuela Valencia",
  "Vietnam Hanoi",
  "Virginia Norfolk",
  "Virginia Richmond",
  "Washington DC North",
  "Washington DC South",
  "Washington Everett",
  "Washington Kennewick",
  "Washington Seattle",
  "Washington Spokane",
  "Washington Tacoma",
  "Washington Vancouver",
  "Washington Yakima",
  "West Virginia Charleston",
  "Wisconsin Milwaukee",
  "Wyoming Cheyenne",
  "Zambia Lusaka",
  "Zimbabwe Bulawayo",
  "Zimbabwe Harare",
  "Zimbabwe Harare West"
];

  global.PMSMissionList = Object.freeze(missions);
  global.PMSMissionListMetadata = Object.freeze({
    compiledThrough: '2026-07-24',
    sourceYears: Object.freeze([2024, 2025, 2026]),
  });
})(typeof window !== 'undefined' ? window : globalThis);
